<template>
    <div v-if="media" class="list_row">
        <span class="label_title">
            <strong> {{ value.label }}: </strong>
        </span>

        <span class="label_content file_content" @click="downloadFile">
            {{ media && media.name }}
        </span>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import getMediaUrl from '@/helpers/getMediaUrl';

export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            media: null
        };
    },

    async created() {
        if (!this.value.answer) {
            return;
        }

        try {
            this.media = await this.getMedia(this.value.answer);
        } catch (error) {
            console.error(error);

            this.$sentry.captureException(error);
        }
    },

    methods: {
        ...mapActions({
            getMedia: 'media/show'
        }),
        async downloadFile() {
            if (!this.media) {
                this.$toasted.global.error();

                return;
            }

            const url = getMediaUrl(this.media);

            this.$downloadFile(
                url,
                this.media.name,
                ['video', 'pdf', 'audio'].includes(this.media.type)
            );
        }
    }
};
</script>
